export default {"src":"/_next/static/media/goIcon.ac4ffac1.svg","height":32,"width":32};